module.exports = __webpack_public_path__ + "media/images/features/support/thumb-voice-1-50536c96bc4bf7bbb1c9a031cc6fdef5.jpg";